var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFilesAndfolderIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "FILES_AND_FOLDER",
    "data-name": "FILES AND FOLDER",
    xmlns: "http://www.w3.org/2000/svg",
    width: 69.104,
    height: 76.288,
    viewBox: "0 0 69.104 76.288",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_36514",
    "data-name": "Path 36514",
    d: "M318.856,23.167a113.753,113.753,0,0,0,14.948.609l-.012-.019A80.184,80.184,0,0,0,311.406,1.31a113.587,113.587,0,0,0,.609,15.022A8.328,8.328,0,0,0,318.856,23.167Z",
    transform: "translate(-272.159 -1.115)",
    fill: "#434343"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_36515",
    "data-name": "Path 36515",
    d: "M323.346,308.16a15.186,15.186,0,1,0,15.186,15.186A15.186,15.186,0,0,0,323.346,308.16Zm7.271,14.9a2.086,2.086,0,0,1-2.95,0l-2.235-2.235v10.062a2.086,2.086,0,0,1-4.172,0V320.832l-2.235,2.235a2.086,2.086,0,1,1-2.95-2.95l5.8-5.795a2.086,2.086,0,0,1,2.95,0l5.8,5.795a2.086,2.086,0,0,1,0,2.95Z",
    transform: "translate(-269.429 -262.244)",
    fill: "#434343"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_36516",
    "data-name": "Path 36516",
    d: "M110,26.646c-.992.025-1.983.042-2.97.042a118.578,118.578,0,0,1-12.541-.669h-.036a11.789,11.789,0,0,1-6.872-3.469,11.746,11.746,0,0,1-3.469-6.87.291.291,0,0,0,0-.036A118.362,118.362,0,0,1,83.483.051a179.975,179.975,0,0,0-23.45.966A13.165,13.165,0,0,0,49.24,11.811c-1.363,12.762-1.363,36.459,0,49.221A13.163,13.163,0,0,0,60.034,71.825a179.693,179.693,0,0,0,26.594.866A19.422,19.422,0,0,1,83.8,54.863H63.008a2.086,2.086,0,0,1,0-4.172H85.8a19.583,19.583,0,0,1,6.543-6.3H63.008a2.086,2.086,0,1,1,0-4.172H95.341A2.086,2.086,0,0,1,97.427,42.3v.012a19.519,19.519,0,0,1,12.635,1.118c.115-5.541.094-11.354-.06-16.786ZM84.917,33.918h-21.9a2.086,2.086,0,0,1,0-4.172h21.9a2.086,2.086,0,1,1,0,4.172Z",
    transform: "translate(-48.218 0.001)",
    fill: "#434343"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilesAndfolderIcon);
export default __webpack_public_path__ + "static/media/FILES_AND FOLDER_icon.9ac29aa6aa0767a50a39c1084600320c.svg";
export { ForwardRef as ReactComponent };